<template>
  <div>
    <surveys-table
      surveyName="RIESGO ASOCIADO"
      surveyCode="RIE_ASO"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_ASSOCIATED_RISK,
        viewDetail: permissions.SEE_DETAIL_SURVEY_ASSOCIATED_RISK,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
